export default () => ({
  isBusy: false,
  instruction: null,
  door2DoorService: [],
})
